import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { Observable } from "rxjs";

export interface MessageDialogData {
  title: string;
  prompt: string;
}

@Component({
  selector: "message-dialog",
  templateUrl: "./message-dialog.component.html",
})
export class MessageDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }

  static showDialog(
    dialog: MatDialog,
    title: string,
    prompt: string
  ): Observable<any> {
    var params: MessageDialogData = {
      title: title,
      prompt: prompt,
    };

    var dialogRef = dialog.open(MessageDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    return dialogRef.afterClosed();
  }
}
